
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-courses",
      function () {
        return require("private-next-pages/my-courses/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-courses"])
      });
    }
  